import React from "react";
import ConnectorPanel from "./ConnectorPanel";

// Freshservice.
//
// Two values: the account's domain and an API key. Every Freshservice account lives on its
// own subdomain (acme.freshservice.com) and the API works only there, never on a custom
// domain, so the domain decides where the key is sent. The server accepts it as a single
// label and fixes the rest itself — pasting the whole address bar works, but nothing typed
// here can aim the key at another host.
//
// Nothing is registered on our side: the key belongs to an agent in the MSP's own
// Freshservice account, so there is no platform app and no OAuth consent.

const FIELDS = [
  {
    key: "subdomain",
    label: "Freshservice domain",
    required: true,
    help: "The \"acme\" in acme.freshservice.com. Pasting the full address works too.",
  },
  {
    key: "api_key",
    label: "API key",
    secret: true,
    required: true,
    help: "Profile picture → Profile Settings → Your API Key.",
  },
];

const HELP = {
  summary: "Match scanned hosts to Freshservice assets and pull their OS and hardware detail.",
  // Assets belong to a department, which Freshservice for MSPs shows as a Company. The
  // panel names both so either kind of account recognises the mapping table.
  customerNoun: "Freshservice department (company)",
  steps: [
    "In Freshservice, sign in as an agent who can view assets and departments. The key carries that agent's access, and this connector only ever reads.",
    "Open your profile picture (top right) → Profile Settings → Your API Key, and copy it.",
    "Enter your Freshservice domain and the key here, press Connect, then Test connection.",
    "After the first sync, map each department or company to a Pipsqueak organization.",
  ],
};

const FreshservicePanel = ({ isAdmin }) => (
  <ConnectorPanel
    isAdmin={isAdmin}
    provider="freshservice"
    title="Freshservice"
    fields={FIELDS}
    help={HELP}
  />
);

export default FreshservicePanel;
